// This import loads the firebase namespace along with all its type information.
import MetricResult from './metric-result-model'

export async function load_metricResults(): Promise<MetricResult[]> {
  throw 'Not implemented'
}

export async function delete_metricResult(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_metricResult(): Promise<MetricResult> {
  throw 'Not implemented'
}
